import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lx-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  imports: [],
})
export class LabelComponent {
  text = input.required<string>();
}
